import * as Sentry from "@sentry/react";
import { store } from "../redux/store";
import axiosInstance from "./axiosConfig";
import { lawyerSelectors } from "../redux/lawyer/selectors";

export interface FreeTrialStatus {
  freeTrialEndDate: string | null;
}

export const getFreeTrialStatus = async (): Promise<FreeTrialStatus> => {
  try {
    const state = store.getState();
    const lawyerId = lawyerSelectors.selectUid(state);

    if (!lawyerId) {
      throw new Error("No lawyer ID found");
    }

    const response = await axiosInstance.get(
      "/subscriptions/free-trial-status",
      {
        params: {
          lawyerId
        }
      }
    );
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    return {
      freeTrialEndDate: null
    };
  }
};

export enum SubscriptionStatus {
  ACTIVE = "active",
  PAUSED = "paused",
  CANCELLED = "cancelled"
}

interface SubscriptionStatusResponse {
  status: SubscriptionStatus;
}

export const getSubscriptionStatus =
  async (): Promise<SubscriptionStatusResponse> => {
    try {
      const state = store.getState();
      const lawyerId = lawyerSelectors.selectUid(state);

      if (!lawyerId) {
        throw new Error("No lawyer ID found");
      }

      const response = await axiosInstance.get("/subscriptions/status", {
        params: {
          lawyerId
        }
      });
      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      return {
        status: SubscriptionStatus.CANCELLED
      };
    }
  };
